<template lang='pug'>
    // 主要列表區
    #GPT.main-page.page-noScroll.pb-0.position-relative(:class="user_mode ? 'upportal-color' : 'GPT-color'" style='height: 100vh;')
        loading-overlay(v-show='loading' message='Loading . . .' :zIndex='999')
        // 標題行
        div.d-flex.align-center.px-0.pb-0.px-md-2.pb-md-4.mt-sm-0.mt-15
            span.ml-4.mr-2(style='font-weight: 700; font-size: 28px; letter-spacing:0.5px; ') {{$t("AGENT.TITLE")}}
            span.mt-2(style='font-weight: 400; font-size: 16px; letter-spacing:0.5px; color:#666;') preview
            v-btn.white--text.ml-4(@click="addAgent" height='40' :ripple='false' color='#14C6DE' depressed)
                v-img.mr-1(src="../assets/images/add-white-thin.png" max-height="16" max-width="16")
                span(style='font-weight: 700; font-size: 16px;') {{$t("AGENT.ADD_AGENT")}}
        // 清單內容
        #page-inner.scroll-x.pb-0(style='max-height: 95% !important;')
            div
                v-row.pb-6.agents-row.d-flex.align-start
                    v-col
                        v-chip.mr-3(v-for="agentfilter in agentfilterStyleList" :key="agentfilter.key" text-color="#444"  :class="agentfilter.active?'agentfilter-active':'agentfilter-default'" :color="agentfilter.active?'#CCC': '#F4F4F4'" flat style='font-size:15px;' @click="toggleAgentChips(agentfilter)") {{agentfilter.name}}
            div.card-area(v-if='!loading' style='min-height: calc(79vh) !important; max-height: calc(79vh) !important; overflow: auto;')
                v-container.upgpt-container(max-content)
                    v-row.agents-row.d-flex.align-start.justify-sm-start.justify-center.pl-4.pt-4
                        v-col(class="mt-1" cols="auto" v-for="(agentCardData, index) in AgentsList" :key='agentCardData.id' id="agent_list").pl-0.pt-0
                            agentCard(:agentCardData="agentCardData" :user_mode="false" :allow_click="true" @openSelectDrawer="open_select_drawer" @emitDeleteAgent='onEmitDeleteAgentDetail' @showErrorDialog="showErrorDialog")
        v-navigation-drawer.drawerShadow(v-model='showEditAdvanceAgentDrawer' absolute right hide-overlay :width="endPointDrawerWidth" style='z-index: 21;' )
            agent-detail-and-run-dialog(@emitAgentDetailAndRunDrawer='onEmitAgentDetailAndRunDrawer' @emitCloseAgentDrawer='onEmitCloseAgentDrawer' :addBtnLoading="childAddBtnLoading" :lock="childEditMode" :showrun="can_run_agent" :agentdetail="agent_detail" :FileAttachments="file_attachments" :ImageAttachments="image_attachments" :agentmode="agent_mode")
        v-navigation-drawer.drawerShadow(v-model='showAddAgentDrawer' absolute right hide-overlay :width="endPointDrawerWidth" style='z-index: 21;')
            add-agent(@emitCloseAgentDrawer='onEmitCloseAgentDrawer' @getAgentListData='getAgentListData' :user_mode="false" :knowledge-list="dropdownSelectedKBList" :knowledge-list-private="KnowledgeListPrivate" :allKnowledgeColor="allKnowledgeColor" :selectionMode.sync="selectionMode" :folderTreeOptions="folderTreeOptions" :hide-favorites="true")
        v-navigation-drawer.drawerShadow(v-model='showEditAgentDrawer' absolute right hide-overlay :width="endPointDrawerWidth" style='z-index: 30;')
            edit-agent(@emitCloseAgentDrawer='onEmitCloseAgentDrawer' @getAgentListData='getAgentListData' :agentdetail="agent_detail" :user_mode="false" :knowledge-list="dropdownSelectedKBList" :knowledge-list-private="KnowledgeListPrivate" :allKnowledgeColor="allKnowledgeColor" :selectionMode.sync="selectionMode" :folderTreeOptions="folderTreeOptions" :hide-favorites="true")
        v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
            success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
        v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
            error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
        v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitMessageDialog(false)' @keydown.enter='onEmitMessageDialog(true)')
            message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
    
</template>

<script>
import i18n from '/common/plugins/vue-i18n.js';
import UpGPTPortalDataServices from "@/services/UpGPTPortalDataServices";
import KnowledgeLibraryService from "../services/KnowledgeLibraryService";
import loadingOverlay from "@/components/Common/loadingOverlay";
import successDialog from "@/components/Dialog/successDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import messageDialog from "@/components/Dialog/messageDialog";
import agentDetailAndRunDialog from "@/components/GPT_Common/agentDetailAndRunDialog";
import agentCard from "@/components/Common/agentCard";
import addAgent from '../components/GPT_Common/addAgent.vue';
import editAgent from '../components/GPT_Common/editAgent.vue';
import Vue from 'vue';

export default {
    name: 'agentslist',
    props: {

    },
    components: {
        agentCard,
        loadingOverlay,
        successDialog,
        errorDialog,
        messageDialog,
        agentDetailAndRunDialog,
        addAgent,
        editAgent
    },
    data() {
        return{
            childAddBtnLoading: false,
            childEditMode: true,
            can_run_agent:false,
            loading:false,
            AgentsList:[],
            selected_agent_id: "",
            agent_detail:{},
            knowledge_lib_background_colors: ['#9ACFFF', '#F6C2C2', '#DEC5F6', '#9ACFFF', '#F6C2C2', '#DEC5F6' ],
            dropdownSelectedKBList:[],
            allKnowledgeColor:[],
            folderTreeOptions:[],
            selectionMode: 'knowledge_lib',
            KnowledgeListPrivate: [],
            // Dialog
            showEditAdvanceAgentDrawer: false,
            showEditAgentDrawer: false,
            successDialog: false,
            successMessage: "",
            errorDialog: false,
            errorMessage: "",
            messageDialog: false,
            message: "",
            user_mode: false,
            agent_mode: "public",
            showAddAgentDrawer: false,
            agentfilterStyleList: [
                {name: 'Simple Agent', key: 'simple_agent', active: false},
                {name: 'Advanced Agent', key: 'advanced_agent', active: true},  
            ],
            agent_style: "advance",
            del_agent_detail: {},
            file_attachments: [],
            image_attachments: [],
        }
    },
    async created() {
        await this.getAgentListData();
        await this.getKnowledgeList();
        await this.defaultColorKnowledgeList();
        if (this.user_mode){
            this.can_run_agent = true;
        }
    },
    methods: {
        async getAgentListData() {
            await UpGPTPortalDataServices.getAgentList(this.agent_style).then((response)=>{
                if(response.data){
                    let data = response.data;
                    data.forEach(item => {
                        item.knowledges = item.linked_agents_and_knowledge_set.map(item=> {return item.knowledge_lib})
                    })
                    this.AgentsList = data;
                }
            })
        },
        async getKnowledgeList(){
            // 使用Portal bot 綁定的知識庫
            await KnowledgeLibraryService.portal_list().then((response)=>{
                this.dropdownSelectedKBList = response.data.portal_knowledge
                this.folderTreeOptions =  response.data.portal_knowledge_folder
            })
        },
        defaultColorKnowledgeList() {
            const colors = ['#9ACFFF', '#F6C2C2', '#DEC5F6'];
            this.allKnowledgeColor = this.dropdownSelectedKBList.map((item, index) => ({
                name: item.name,
                color: colors[index % colors.length]
            }));
        },
        checkCanView(nodes) {
            if (!Array.isArray(nodes)) return [];

            return nodes.map(node => {
                // 先遞迴過濾 children
                const filteredChildren = node.children?this.checkCanView(node.children):[];
                const canViewSelf = node.perm.can_view === true;

                // 只要自己能看 或 子層還有東西 → 保留
                if (canViewSelf || filteredChildren.length > 0) {
                    return {
                        ...node,
                        children: filteredChildren
                    };
                }
                return null;
            }).filter(Boolean);
        },
        async getAgentDetail(id) {
            try {
                const response = await UpGPTPortalDataServices.getAgentDetail(id);
                const data = response.data || {};

                // Align with editAgent.vue expected structure.
                data.knowledges = (data.linked_agents_and_knowledge_set || [])
                    .map((item) => item.knowledge_lib)
                    .filter(Boolean);

                data.folders = (data.linked_agents_and_knowledge_folder_set || [])
                    .map((item) => item.knowledge_folder || item.folder)
                    .filter(Boolean);

                this.agent_detail = data;
            } catch (error) {
                this.showErrorDialog(String(error));
                throw error;
            }
        },
        async open_select_drawer(data){
            this.showAddAgentDrawer = false;
            await this.getAgentDetail(data.id);
            console.log(data);
            // 取得 files
            let user = JSON.parse(window.localStorage.getItem('user'));
            let file_data = {
                agent_id: this.agent_detail.id,
                tenant: window.localStorage.getItem('tenant'),
                user_id: user["userid"],
                mode: "public"
            };
            try{ 
                // 這裡要能判斷是不是第public private的load的files，可以看看後端的邏輯
                let response = await UpGPTPortalDataServices.getAgentUploadedFiles(file_data);
                let data = response.data;
                if (data.document && Object.keys(data.document).length > 0) {
                    Object.keys(data.document).forEach(key => {
                        let details = data.document[key];
                        // if (details && details.length > 0) {
                        //     let firstchunk = details[0];
                        //     let blob;
                        //     blob = new Blob([details]);
                        //     let file = new File([blob], firstchunk.file_name);
                        //     Vue.set(this.file_attachments, key, file);
                        // }
                        Vue.set(this.file_attachments,key, details);
                    });
                } else if (data.upload_status != "completed") {
                        this.showErrorDialog(i18n.t('AGENT_FILE_ATTACHMENT.STILL_RUN'));
                        this.childAddBtnLoading = true;
                        this.childEditMode = false;
                } else {
                    this.file_attachments = [];
                }

                if (data.image && Object.keys(data.image).length > 0) {
                    console.log(data.image);
                    // 要組成image b64放到image_attachments裡面
                } else {
                    this.image_attachments = [];
                }
            } catch(error) {
                console.log(error);
            }
            const agentStyle = this.agent_detail.agent_style || data.agent_style;
            if (agentStyle == "simple"){
                this.showEditAgentDrawer = true;
                this.showEditAdvanceAgentDrawer = false;
            }else if(agentStyle == "advance") {
                this.showEditAdvanceAgentDrawer = true;
                this.showEditAgentDrawer = false;
            }
        },
        // Dialog Area ----------------------------------------- [Start]
        onEmitAgentDetailAndRunDrawer(agentUserInput){
            this.showEditAdvanceAgentDrawer = false;
            this.agent_detail = {};
            this.$emit("runAgentProcess",agentUserInput);
        },
        onEmitCloseAgentDrawer(type){
            if(type == "addSimpleAgent"){
                this.showAddAgentDrawer = false;
            }else if(type == "editSimpleAgent"){
                this.showEditAgentDrawer = false;
                this.getAgentListData();
            }else if(type == "editAdvanceAgent"){
                this.showEditAdvanceAgentDrawer = false;
                this.agent_detail = {};
                this.file_attachments = [];
                this.image_attachments = [];
            }
        },
        showSuccessDialog() {
            this.successDialog = true;
        },
        onEmitSuccessDialog() {
            this.successDialog = false;
        },
        showErrorDialog(message) {
            this.errorDialog = true;
            this.errorMessage = message;
        },
        onEmitErrorDialog() {
            this.errorDialog = false;
        },
        showMessageDialog(message) {
            this.messageDialog = true;
            this.message = message;
        },
        async onEmitMessageDialog(val) {
            if(val && this.delMode == 'delSimpleAgnet'){
                await UpGPTPortalDataServices.deleteAgent(this.del_agent_detail.id);
                await this.getAgentListData();
            }
            this.messageDialog = false;
        },
        addAgent(){
            this.showAddAgentDrawer = true;
            this.showEditAdvanceAgentDrawer = false;
            this.showEditAgentDrawer = false;
        },
        async toggleAgentChips(filter){
            let agentGroup = ['simple_agent', 'advanced_agent'];
            // let privacyGroup = ['private', 'public'];
            if(agentGroup.includes(filter.key)){
                this.agentfilterStyleList.forEach(f => {
                    if(agentGroup.includes(f.key)){
                        f.active = (f.key == filter.key) ? !filter.active : false;
                    }
                })
                // 更新 agent_style
                let selected = this.agentfilterStyleList.find(f => agentGroup.includes(f.key) && f.active);
                this.agent_style = selected ? (selected.key == "simple_agent" ? "simple" : "advance") : null;
            }
            await this.getAgentListData();
        },
        onEmitDeleteAgentDetail(data){
            this.del_agent_detail = data;
            this.delMode = 'delSimpleAgnet';
            this.messageDialog = true;
            this.showEditAgentDrawer = false;
            this.message = i18n.t('PORTAL.MESSAGE_DELETE') + data.agent_name
        },
    },
    watch: {
    },
    computed: {
        endPointDrawerWidth(){
            const { xs, sm, md, lg, xl } = this.$vuetify.breakpoint
            if (xs) return '100%'
            if (sm) return '50%'
            if (md) return '45%'
            if (lg) return '29%'
            if (xl) return '29%'
            return '29%';
        },
    }
}
</script>